module.exports = __webpack_public_path__ + "img/hotel_thumbnail-400x300.8348ba1a.jpg";